export interface SafeErrorInfo {
  name?: string;
  code?: string | number;
  message: string;
  response?: Record<string, unknown>;
}

export const getSafeErrorInfo = (error: unknown): SafeErrorInfo => {
  const err = typeof error === 'object' && error !== null ? (error as Record<string, unknown>) : {};

  const name = typeof err.name === 'string' ? err.name : undefined;
  const code = typeof err.code === 'string' || typeof err.code === 'number' ? err.code : undefined;
  const message = String(err.message ?? 'Unknown error').substring(0, 200);
  const response =
    typeof err.response === 'object' && err.response !== null
      ? (err.response as Record<string, unknown>)
      : undefined;

  return { name, code, message, response };
};
